export class SimpleListModel {
    idx: number;
    s: string;
}